module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-04-b56bf20f75fba9b46972607c1b80b5db.jpg";